import supabaseClient from '@/api/supabaseClient.ts';
import { useQuery } from '@tanstack/react-query';

export type Carer = {
  id: string;
  email: string;
  role: string;
  is_verified: boolean;
  is_hidden: boolean;
  first_name: string | null;
  last_name: string | null;
  gender: string | null;
  phone_number: string | null;
  city_town: string | null;
  postcode: string | null;
  created_at: string;
};

const useAdminCarers = () => {
  const queryFn = async (): Promise<Carer[]> => {
    const { data, error } = await supabaseClient
      .from('users')
      .select('*')
      .eq('role', 'business_provider')
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching carers:', error);
      throw new Error(error.message);
    }

    return data || [];
  };

  return useQuery<Carer[], Error>({
    queryKey: ['admin-carers'],
    queryFn,
  });
};

export default useAdminCarers;
